import { useEffect, useState, useRef } from "react";
import style from "./Topbar.module.css";
import { FaUserCircle, FaRegBell } from "react-icons/fa";
import { RiApps2AiLine } from "react-icons/ri";
import logoIteraBranca from "../../assets/logoIteraBranca.png";
import ModalUsuarioInfo from "./modalUsuarioInfo/ModalUsuarioInfo";
import ModalMensagem from "./modalMensagem/ModalMensagem";
import ModalApps from "./modalApps/ModalApps";
import NotificacaoApi from "../../services/NotificacaoApi";
import MenuHamburguer from "../menuHamburguer/MenuHambueguer";

function Topbar({ children, menuHamburguerAberto, setMenuHamburguerAberto }) {
  const [mostrarModalUsuario, setMostrarModalUsuario] = useState(false);
  const [mostrarModalMensagem, setMostrarModalMensagem] = useState(false);
  const [mostrarModalApp, setMostrarModalApp] = useState(false);
  const [quantidadeNotificacoesNaoLidas, setQuantidadeNotificacoesNaoLidas] =
    useState(0);
  const botaoRef = useRef(null);

  async function QuantidadeNotificacoesNaoLidas() {
    try {
      const quantidade =
        await NotificacaoApi.QuantidadeNotificacoesUsuarioAsync();
      setQuantidadeNotificacoesNaoLidas(quantidade);
    } catch (error) { }
  }

  useEffect(() => {
    QuantidadeNotificacoesNaoLidas();
  }, []);
  return (
    <div>
      <div className={style.topbar_conteudo}>
        <div className={style.container_menu_logo}>
          <div className={style.container_menu_hamburguer}>
            <MenuHamburguer
              menuHamburguerAberto={menuHamburguerAberto}
              setMenuHamburguerAberto={setMenuHamburguerAberto}
            />
          </div>
          <div className={style.container_logo}>
            <a href="/" >  <img src={logoIteraBranca} alt="Logo da itera360" /></a>
          </div>
        </div>

        <div className={style.container_info}>
          <div>
            <button
              ref={botaoRef}
              onClick={() => setMostrarModalApp(true)}
              className={style.botoes_modais}
            >
              <RiApps2AiLine />
            </button>
            <ModalApps
              mostrar={mostrarModalApp}
              aoFechar={() => setMostrarModalApp(false)}
              botaoRef={botaoRef}
            />
          </div>

          <div>
            <button
              ref={botaoRef}
              onClick={() => setMostrarModalMensagem(true)}
              className={style.botoes_modais}
            >
              <FaRegBell />
              {quantidadeNotificacoesNaoLidas > 0 && <div className={style.exibir_numero_notificacoes}>
                <span className={style.numero_notificacoes}>
                  {quantidadeNotificacoesNaoLidas}
                </span>
              </div>}
            </button>
            <ModalMensagem
              mostrar={mostrarModalMensagem}
              aoFechar={() => setMostrarModalMensagem(false)}
              botaoRef={botaoRef}
            />
          </div>

          <div>
            <button
              ref={botaoRef}
              onClick={() => setMostrarModalUsuario((prev) => !prev)}
              className={style.botoes_modais}
            >
              <FaUserCircle />
            </button>
            <ModalUsuarioInfo
              mostrar={mostrarModalUsuario}
              aoFechar={() => setMostrarModalUsuario(false)}
              botaoRef={botaoRef}
            />
          </div>
        </div>
      </div>

      <div className={style.pagina_conteudo}>{children}</div>
    </div>
  );
}




export default Topbar;
